import { h } from 'preact'
import IconEmptySet from "./icons/IconEmptySet"

const NoDataWidgetError = ({ message }) => (
    <div  class="fxs_widget-error">
        <p class="fxs_txt_center">
            <IconEmptySet />
        </p>
        <p class="fxs_txt_center">
            {message}
        </p>
    </div>
    )

export default NoDataWidgetError